/* ============================================================
   MSOG — scroll engine
   Canvas frame-sequence scrub sections + slow lingering overlay copy
   + scroll reveals + counters
   ============================================================ */
function initScrub(cfg) {
  const section = document.querySelector(cfg.section);
  const canvas  = section.querySelector("canvas");
  const ctx     = canvas.getContext("2d", { alpha: false });
  const lines   = [...section.querySelectorAll(".reveal-line")];
  const bar     = section.querySelector(".progress-fill");
  const bgFill  = cfg.bg || "#1f1b2e";
  const images = [];
  let firstDrawn = false, preloadStarted = false, current = -1;

  function loadFrame(i) {
    if (images[i]) return;
    const img = new Image();
    img.decoding = "async";
    img.src = cfg.framePath(i + 1);
    img.onload = () => {
      if (!firstDrawn) { firstDrawn = true; draw(0); }
      else if (i === current) draw(i);
    };
    images[i] = img;
  }
  function preloadAll() {
    if (preloadStarted) return;
    preloadStarted = true;
    let i = 0;
    (function wave() {
      for (let n = 0; n < 24 && i < cfg.frameCount; n++, i++) loadFrame(i);
      if (i < cfg.frameCount) setTimeout(wave, 120);
    })();
  }
  loadFrame(0);

  function draw(index) {
    const img = images[index];
    if (!img || !img.complete || !img.naturalWidth) return;
    const cw = canvas.clientWidth, ch = canvas.clientHeight;
    const ir = img.naturalWidth / img.naturalHeight, cr = cw / ch;
    let dw, dh, dx, dy;
    if (ir > cr) { dh = ch; dw = ch * ir; dx = (cw - dw) / 2; dy = 0; }
    else         { dw = cw; dh = cw / ir; dx = 0; dy = (ch - dh) / 2; }
    ctx.fillStyle = bgFill; ctx.fillRect(0, 0, cw, ch);
    ctx.drawImage(img, dx, dy, dw, dh);
  }
  function resize() {
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    const cw = canvas.clientWidth, ch = canvas.clientHeight;
    if (!cw || !ch) return;
    const w = Math.round(cw * dpr), h = Math.round(ch * dpr);
    if (canvas.width === w && canvas.height === h) return;
    canvas.width = w; canvas.height = h;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    draw(current < 0 ? 0 : current);
  }
  function update() {
    const rect = section.getBoundingClientRect();
    if (!preloadStarted && rect.top < window.innerHeight * 2.5 && rect.bottom > -window.innerHeight) preloadAll();
    if (rect.bottom < -window.innerHeight || rect.top > window.innerHeight) return;
    const scrollable = rect.height - window.innerHeight;
    const p = Math.min(Math.max(-rect.top / scrollable, 0), 1);
    const idx = Math.min(cfg.frameCount - 1, Math.floor(p * (cfg.frameCount - 1)));
    if (idx !== current) {
      current = idx; draw(idx);
      if (bar) bar.style.width = (p * 100).toFixed(1) + "%";
    }
    // Overlay copy: each line owns a [in,out] window of section progress.
    // Plateau in the middle, very slow ease at the edges so text lingers
    // and dissolves gently as the visitor keeps scrolling.
    for (const el of lines) {
      const a = parseFloat(el.dataset.in), b = parseFloat(el.dataset.out);
      const mid = (a + b) / 2, half = (b - a) / 2;
      let o = 1 - Math.abs(p - mid) / half;
      o = Math.max(0, Math.min(1, o));
      o = Math.min(1, o / 0.55);          // fully visible for the middle 45% of the window
      o = Math.pow(o, 0.7);               // soft, slow shoulders
      el.style.opacity = o.toFixed(3);
      el.style.transform = `translateY(${(1 - o) * 10}px)`;
    }
  }
  new ResizeObserver(resize).observe(canvas);
  window.addEventListener("resize", resize);
  resize();
  return { update, resize };
}

function animateCount(el) {
  const target = parseFloat(el.dataset.count), suffix = el.dataset.suffix || "";
  const dur = 1600, t0 = performance.now();
  function step(t) {
    const k = Math.min((t - t0) / dur, 1), eased = 1 - Math.pow(1 - k, 3);
    el.textContent = (target % 1 === 0 ? Math.round(target*eased) : (target*eased).toFixed(1)) + suffix;
    if (k < 1) requestAnimationFrame(step);
  }
  requestAnimationFrame(step);
}

document.addEventListener("DOMContentLoaded", () => {
  const scrubs = (window.SCRUB_SECTIONS || [])
    .filter(c => document.querySelector(c.section))
    .map(initScrub);
  window.__scrubs = scrubs;

  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const lenis = new Lenis({ lerp: reduce ? 1 : 0.075, smoothWheel: !reduce });
  window.__lenis = lenis;
  function raf(t) { lenis.raf(t); scrubs.forEach(s => s.update()); requestAnimationFrame(raf); }
  requestAnimationFrame(raf);

  // slow parallax on panel images
  const px = [...document.querySelectorAll("[data-parallax]")];
  lenis.on("scroll", ({ scroll }) => {
    document.querySelectorAll(".scroll-hint").forEach(h => h.style.opacity = scroll > 60 ? "0" : "1");
    for (const el of px) {
      const r = el.getBoundingClientRect();
      const k = (r.top + r.height / 2 - window.innerHeight / 2) / window.innerHeight;
      el.style.transform = `translateY(${(k * -parseFloat(el.dataset.parallax || 30)).toFixed(1)}px) scale(1.08)`;
    }
  });

  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (!e.isIntersecting) return;
      e.target.classList.add("in");
      if (e.target.classList.contains("stat-num")) animateCount(e.target);
      io.unobserve(e.target);
    });
  }, { threshold: 0.2 });
  document.querySelectorAll(".reveal, .stat-num").forEach((el) => io.observe(el));

  // smooth anchor links through Lenis
  document.querySelectorAll('a[href^="#"]').forEach(a => a.addEventListener("click", ev => {
    const t = document.querySelector(a.getAttribute("href"));
    if (t) { ev.preventDefault(); lenis.scrollTo(t, { offset: -20, duration: 1.6 }); }
  }));
});
